// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/index.js!./swiper.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../vue-style-loader/lib/addStylesClient.js")("98dc4072", content, true);


//////////////////
// WEBPACK FOOTER
// /~/swiper/dist/css/swiper.css
// module id = 422
// module chunks = 1